export default __webpack_public_path__ + "static/media/img_4.8c701dd5.jpeg";